import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "data",
  initialState: {
    datasets: {},
    filters: {},
    policiesData: {},
    op_strategiesData: {},
    lessons_learnedData: {},
    testData: {},
    loading: false,
    error: null,
  },
  reducers: {
    fetchDataRequest: (state, action) => {
      const datasetName = action.payload;
      state.loading = true;
      state.error = null;
      if (!state.datasets[datasetName]) {
        state.datasets[datasetName] = [];
      }
    },
    fetchDataSuccess: (state, action) => {
      const { datasetName, data } = action.payload;
      state.loading = false;
      state.datasets[datasetName] = data;
    },
    fetchDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchFiltersRequest: (state, action) => {
      const datasetName = action.payload;
      state.loading = true;
      state.error = null;
      if (!state.filters[datasetName]) {
        state.filters[datasetName] = [];
      }
    },
    fetchFiltersSuccess: (state, action) => {
      const { datasetName, data } = action.payload;
      state.loading = false;
      state.filters[datasetName] = data;
    },
    fetchFiltersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Action for policies data request
    fetchPoliciesDataRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchPoliciesDataSuccess: (state, action) => {
      state.loading = false;
      state.policiesData = action.payload;
    },
    fetchPoliciesDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Action for op_strategies data request
    fetchOpStrategiesDataRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOpStrategiesDataSuccess: (state, action) => {
      state.loading = false;
      state.op_strategiesData = action.payload;
    },
    fetchOpStrategiesDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Action for lessons_learned data request
    fetchLessonsLearnedDataRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLessonsLearnedDataSuccess: (state, action) => {
      state.loading = false;
      state.lessons_learnedData = action.payload;
    },
    fetchLessonsLearnedDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Action for test data request
    fetchTestDataRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchTestDataSuccess: (state, action) => {
      state.loading = false;
      state.testData = action.payload;
    },
    fetchTestDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchDataRequest,
  fetchDataSuccess,
  fetchDataFailure,
  fetchFiltersRequest,
  fetchFiltersSuccess,
  fetchFiltersFailure,
  fetchPoliciesDataRequest,
  fetchPoliciesDataSuccess,
  fetchPoliciesDataFailure,
  fetchOpStrategiesDataRequest,
  fetchOpStrategiesDataSuccess,
  fetchOpStrategiesDataFailure,
  fetchLessonsLearnedDataRequest,
  fetchLessonsLearnedDataSuccess,
  fetchLessonsLearnedDataFailure,
  fetchTestDataRequest,
  fetchTestDataSuccess,
  fetchTestDataFailure,
} = dataSlice.actions;

export default dataSlice.reducer;
